<portals-navbar></portals-navbar>
<portals-try-jotto></portals-try-jotto>
<portals-jotto-description></portals-jotto-description>
<portals-trusted-by-carousel></portals-trusted-by-carousel> 
<portals-customer-carousel></portals-customer-carousel>
<portals-qr-panel></portals-qr-panel>
<portals-footer></portals-footer>
